/** @jsx jsx */
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from '@stripe/react-stripe-js'
import {
  StripeCardCvcElementChangeEvent,
  StripeCardExpiryElementChangeEvent,
  StripeCardNumberElementChangeEvent,
} from '@stripe/stripe-js'
import {ChangeEvent, Dispatch, SetStateAction} from 'react'
import {toast} from 'react-toastify'
import {jsx} from 'theme-ui'
import Input from '../Input'
import {useTranslation} from 'react-i18next'

interface IPaymentFormStripeProps {
  payerName: string
  setPayerName: (payerName: string) => void
  setStripeElementsComplete: Dispatch<
    SetStateAction<{
      cardNumber: boolean
      cardExpiry: boolean
      cardCvc: boolean
    }>
  >
}

const PaymentFormStripe: React.FC<IPaymentFormStripeProps> = ({
  setPayerName,
  payerName,
  setStripeElementsComplete,
}) => {
  const {t} = useTranslation()
  const handlePayerNameChange = (e: ChangeEvent<HTMLInputElement>) => {
    setPayerName(e.target.value)
  }
  const handleStripeElementChange = (
    changeEvent:
      | StripeCardNumberElementChangeEvent
      | StripeCardExpiryElementChangeEvent
      | StripeCardCvcElementChangeEvent,
  ) => {
    const {elementType, complete, error} = changeEvent
    if (error) {
      toast.error(error.message)
    }
    setStripeElementsComplete((oldState) => ({
      ...oldState,
      [elementType]: complete,
    }))
  }
  return (
    <div
      sx={{
        pt: 16,
        px: 12,
        pb: 26,
      }}
    >
      <Input
        name={name}
        onChange={handlePayerNameChange}
        type="text"
        autoComplete="name"
        value={payerName}
        placeholder={t('Card holder name')}
        required
      />
      <CardNumberElement
        onChange={handleStripeElementChange}
        sx={{
          mt: 14,
          backgroundColor: '#fff',
          padding: '10px 15px',
          width: '100%',
          height: '100%',
          borderRadius: 4,
          fontSize: 13,
          border: '1px solid #DEE3E3',
          outline: 0,
          '&:focus': {
            border: '1px solid #055064',
            '::placeholder': {
              color: '#055064',
            },
          },
          '::placeholder': {
            color: '#717A7B',
          },
        }}
        options={{
          style: {
            invalid: {
              color: '#9e2146',
            },
          },
        }}
      />
      <div
        sx={{
          mt: 14,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <CardExpiryElement
          onChange={handleStripeElementChange}
          sx={{
            backgroundColor: '#fff',
            padding: '10px 15px',
            width: 140,
            height: '100%',
            borderRadius: 4,
            fontSize: 13,
            border: '1px solid #DEE3E3',
            outline: 0,
            '&:focus': {
              border: '1px solid #055064',
              '::placeholder': {
                color: '#055064',
              },
            },
            '::placeholder': {
              color: '#717A7B',
            },
          }}
        />
        <CardCvcElement
          onChange={handleStripeElementChange}
          sx={{
            backgroundColor: '#fff',
            padding: '10px 15px',
            width: 140,
            height: '100%',
            borderRadius: 4,
            fontSize: 13,
            border: '1px solid #DEE3E3',
            outline: 0,
            '&:focus': {
              border: '1px solid #055064',
              '::placeholder': {
                color: '#055064',
              },
            },
            '::placeholder': {
              color: '#717A7B',
            },
          }}
        />
      </div>
    </div>
  )
}

export default PaymentFormStripe
